import { getPropsWithCompliantTitleId } from "./appIdUtils";
import type { LogModules } from "./enum";
import { type LogLevel } from "./enum";
import type { PropertiesType } from "./types/PropertiesType";
import { logCoreUsage } from "owa-analytics";
// Logger functions use getModuleContextMailboxInfo() because they are generic helpers called
// from service/utility code that has no per-account context. Fully correct attribution would
// require threading an optional mailboxInfo parameter, but that is a larger structural change.
import { getModuleContextMailboxInfo } from "owa-module-context-mailboxinfo";

/**
 * @function
 * To log Error messages
 */
export const logError = (logModule: LogModules, logMessage: string, _appId: string, correlationId: string, properties?: PropertiesType): void => {
    let propsWithCompliantTitleId: PropertiesType = {};
    if (properties) {
        propsWithCompliantTitleId = getPropsWithCompliantTitleId(properties);
    }
    logCoreUsage("MessageExtensionLogs", getModuleContextMailboxInfo(), {
        LogLevel: "Error",
        LogModule: logModule,
        LogMessage: logMessage,
        CorrelationId: correlationId ? correlationId : "",
        ...propsWithCompliantTitleId,
    });
};

/**
 * @function
 * To log Warnings
 */
export const logWarning = (logModule: LogModules, logMessage: string, _appId: string, correlationId: string, properties?: PropertiesType): void => {
    let propsWithCompliantTitleId: PropertiesType = {};
    if (properties) {
        propsWithCompliantTitleId = getPropsWithCompliantTitleId(properties);
    }
    logCoreUsage("MessageExtensionLogs", getModuleContextMailboxInfo(), {
        LogLevel: "Warning",
        LogModule: logModule,
        LogMessage: logMessage,
        CorrelationId: correlationId ? correlationId : "",
        ...propsWithCompliantTitleId,
    });
};

/**
 * @function
 * To log Information
 */
export const logInfo = (logModule: LogModules, logMessage: string, _appId: string, correlationId: string, properties?: PropertiesType): void => {
    let propsWithCompliantTitleId: PropertiesType = {};
    if (properties) {
        propsWithCompliantTitleId = getPropsWithCompliantTitleId(properties);
    }
    logCoreUsage("MessageExtensionLogs", getModuleContextMailboxInfo(), {
        LogLevel: "Info",
        LogModule: logModule,
        LogMessage: logMessage,
        CorrelationId: correlationId ? correlationId : "",
        ...propsWithCompliantTitleId,
    });
};

/**
 * @function
 * To log user actions
 */
export const logAction = (logModule: LogModules, action: string, _appId: string, correlationId: string, properties?: PropertiesType): void => {
    let propsWithCompliantTitleId: PropertiesType = {};
    if (properties) {
        propsWithCompliantTitleId = getPropsWithCompliantTitleId(properties);
    }
    // Message extension user action logging
    logCoreUsage("MessageExtensionActions", getModuleContextMailboxInfo(), {
        LogModule: logModule,
        Action: action,
        AppId: "",
        CorrelationId: correlationId ? correlationId : "",
        ...propsWithCompliantTitleId,
    });
};
